
import config from '../config.json';
import legal_en from './Legal_en.json'
import legal_hi from './Legal_hi.json'
import legal_ar from './Legal_ar.json'
import family_en from './Family_en.json'
import family_hi from './Family_hi.json'
import family_ar from './Family_ar.json'
import edu_en from './Education_en.json'
import edu_hi from './Education_hi.json'
import edu_ar from './Education_ar.json'
import def_en from './en.json'
import def_hi from './hi.json'
import def_ar from './ar.json'

const en = config.app == "legal" ? legal_en:  config.app == "family"? family_en :config.app == "education"? edu_en:  def_en 
const hi = config.app == "legal" ? legal_hi:config.app == "family"? family_hi :config.app == "education"? edu_hi:  def_hi
const ar = config.app == "legal" ?legal_ar: config.app == "family"? family_ar :config.app == "education"? edu_ar:  def_ar

export const langObj =
{
    en: en,
    hi: hi,
    ar: ar
}